function mergeClassNames(param) {
    var cx = param.cx, classes = param.classes, context = param.context, classNames = param.classNames, name = param.name, cache = param.cache;
    var contextClassNames = context.reduce(function(acc, item) {
        Object.keys(item.classNames).forEach(function(key) {
            if (typeof acc[key] !== "string") {
                acc[key] = "".concat(item.classNames[key]);
            } else {
                acc[key] = "".concat(acc[key], " ").concat(item.classNames[key]);
            }
        });
        return acc;
    }, {});
    return Object.keys(classes).reduce(function(acc, className) {
        acc[className] = cx(classes[className], contextClassNames[className], classNames != null && classNames[className], Array.isArray(name) ? name.filter(Boolean).map(function(part) {
            return "".concat((cache == null ? void 0 : cache.key) || "mantine", "-").concat(part, "-").concat(className);
        }).join(" ") : name ? "".concat((cache == null ? void 0 : cache.key) || "mantine", "-").concat(name, "-").concat(className) : null);
        return acc;
    }, {});
}
export { mergeClassNames }; //# sourceMappingURL=merge-class-names.js.map
